(function () {
  var FIELD_KEYS = ['brand', 'model', 'year'];
  var FIELD_LABELS = {
    brand: 'Brand',
    model: 'Model',
    year: 'Year'
  };
  var CLEAR_LABELS = {
    brand: 'All Brands',
    model: 'All Models',
    year: 'All Years'
  };
  var MOBILE_MEDIA = '(max-width: 740px)';
  var DESKTOP_VISIBLE_LIMIT = 10;
  var MOBILE_COLLAPSED_LIMIT = 5;
  var fitmentIndexCache = new Map();
  var productIndexCache = new Map();

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function compareOption(a, b) {
    return a.label.replace(/^For\s+/i, '').localeCompare(
      b.label.replace(/^For\s+/i, ''),
      undefined,
      { numeric: true, sensitivity: 'base' }
    );
  }

  function compareYearOption(a, b) {
    var aAll = a.label.toLowerCase() === 'all years';
    var bAll = b.label.toLowerCase() === 'all years';
    if (aAll && !bAll) return -1;
    if (!aAll && bAll) return 1;

    var aNum = Number(a.label);
    var bNum = Number(b.label);
    if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) return bNum - aNum;
    return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' });
  }

  function uniqBySlug(values, key) {
    var map = new Map();

    values.forEach(function (value) {
      var label = String(value || '').trim();
      var slug = slugify(label);
      if (!label || !slug || map.has(slug)) return;
      map.set(slug, { label: label, slug: slug });
    });

    return Array.from(map.values()).sort(key === 'year' ? compareYearOption : compareOption);
  }

  function getHeaderOffset() {
    var selectors = [
      'sticky-header',
      '#shopify-section-header',
      '.shopify-section-header',
      '.shopify-section--header',
      'header[role="banner"]',
      'header'
    ];
    var maxBottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        var style = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        var isPinned = style.position === 'fixed' || style.position === 'sticky';
        var isVisible = rect.height > 0 && rect.bottom > 0 && rect.top < 120;

        if (isPinned && isVisible) {
          maxBottom = Math.max(maxBottom, rect.bottom);
        }
      });
    });

    return Math.max(0, Math.round(maxBottom));
  }

  function queryTarget(selector) {
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (error) {
      return null;
    }
  }

  function normalizeProductRefs(refs) {
    return Array.isArray(refs)
      ? refs.map(function (ref) { return Number(ref); }).filter(function (ref) { return Number.isInteger(ref) && ref >= 0; })
      : [];
  }

  function normalizeNode(node) {
    return {
      label: String(node && node.label || '').trim(),
      slug: String(node && node.slug || slugify(node && node.label)).trim(),
      productRefs: normalizeProductRefs(node && node.productRefs)
    };
  }

  function findByLabel(items, label) {
    var target = String(label || '').trim();
    if (!target) return null;
    return (items || []).find(function (item) { return item.label === target; }) || null;
  }

  function findBySlug(items, slug) {
    var target = String(slug || '').trim();
    if (!target) return null;
    return (items || []).find(function (item) { return item.slug === target; }) || null;
  }

  function mergeOptions(items, key, includeAllYears) {
    var map = new Map();

    (items || []).forEach(function (item) {
      if (!item || !item.label || !item.slug) return;
      if (key === 'year' && !includeAllYears && item.label.toLowerCase() === 'all years') return;
      if (!map.has(item.slug)) {
        map.set(item.slug, { label: item.label, slug: item.slug });
      }
    });

    return Array.from(map.values()).sort(key === 'year' ? compareYearOption : compareOption);
  }

  function addRefs(target, refs) {
    normalizeProductRefs(refs).forEach(function (ref) {
      target.add(ref);
    });
  }

  function normalizeFitmentIndex(rawIndex) {
    var index = rawIndex && typeof rawIndex === 'object' ? rawIndex : {};
    var productIds = Array.isArray(index.productIds) ? index.productIds.map(function (id) { return String(id); }) : [];
    var normalized = {
      version: Number(index.version || 0),
      productIds: productIds,
      brands: [],
      _allProductRefs: productIds.map(function (_, ref) { return ref; }),
      _productFitmentsById: new Map(),
      _productIdSetCache: new Map()
    };

    normalized.brands = (Array.isArray(index.brands) ? index.brands : []).map(function (brandNode) {
      var brand = normalizeNode(brandNode);
      brand.models = (Array.isArray(brandNode.models) ? brandNode.models : []).map(function (modelNode) {
        var model = normalizeNode(modelNode);
        model.years = (Array.isArray(modelNode.years) ? modelNode.years : []).map(normalizeNode);
        return model;
      });
      return brand;
    });

    normalized.brands.forEach(function (brand) {
      brand.models.forEach(function (model) {
        model.years.forEach(function (year) {
          year.productRefs.forEach(function (ref) {
            var productId = normalized.productIds[ref];
            if (!productId) return;

            if (!normalized._productFitmentsById.has(productId)) {
              normalized._productFitmentsById.set(productId, []);
            }

            normalized._productFitmentsById.get(productId).push({
              brand: brand.label,
              model: model.label,
              year: year.label
            });
          });
        });
      });
    });

    return normalized;
  }

  function fetchFitmentIndex(section) {
    var url = section.getAttribute('data-am-ymm-fitment-url');
    if (!url) return Promise.resolve(normalizeFitmentIndex(null));

    if (!fitmentIndexCache.has(url)) {
      fitmentIndexCache.set(url, fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load YMM fitment index');
          return response.json();
        })
        .then(normalizeFitmentIndex)
        .catch(function () {
          return normalizeFitmentIndex(null);
        }));
    }

    return fitmentIndexCache.get(url);
  }

  function normalizeProductIndex(rawIndex) {
    var index = rawIndex && typeof rawIndex === 'object' ? rawIndex : {};
    return {
      version: Number(index.version || 0),
      products: index.products && typeof index.products === 'object' ? index.products : {},
      counts: index.counts && typeof index.counts === 'object' ? index.counts : {}
    };
  }

  function fetchProductIndex(section) {
    var url = section.getAttribute('data-am-ymm-product-url');
    if (!url) return Promise.resolve(normalizeProductIndex(null));

    if (!productIndexCache.has(url)) {
      productIndexCache.set(url, fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load YMM product index');
          return response.json();
        })
        .then(normalizeProductIndex)
        .catch(function () {
          return normalizeProductIndex(null);
        }));
    }

    return productIndexCache.get(url);
  }

  function getQueryKey(section, key) {
    var prefix = section.getAttribute('data-query-prefix') || 'bike';
    return prefix + '_' + key;
  }

  function getBrandNode(index, state) {
    return findByLabel(index.brands, state.brand);
  }

  function getAllModels(index) {
    var models = [];
    index.brands.forEach(function (brand) {
      models = models.concat(brand.models);
    });
    return models;
  }

  function getModelNodes(index, state) {
    var brand = getBrandNode(index, state);
    var models = brand ? brand.models : getAllModels(index);

    if (!state.model) return models;

    return models.filter(function (model) {
      return model.label === state.model;
    });
  }

  function getYearNodes(index, state) {
    var years = [];
    getModelNodes(index, state).forEach(function (model) {
      years = years.concat(model.years);
    });
    return years;
  }

  function getOptionsForKey(index, state, key) {
    if (key === 'brand') {
      return mergeOptions(index.brands, key, false);
    }

    if (key === 'model') {
      var brand = getBrandNode(index, state);
      return mergeOptions(brand ? brand.models : getAllModels(index), key, false);
    }

    if (key === 'year') {
      return mergeOptions(getYearNodes(index, state), key, false);
    }

    return [];
  }

  function getStateFromUrl(section, index) {
    var params = new URLSearchParams(window.location.search);
    var state = { brand: '', model: '', year: '' };
    var brandSlug = params.get(getQueryKey(section, 'brand'));
    var modelSlug = params.get(getQueryKey(section, 'model'));
    var yearSlug = params.get(getQueryKey(section, 'year'));
    var brandMatch;
    var modelMatch;
    var yearMatch;

    if (brandSlug) {
      brandMatch = findBySlug(index.brands, brandSlug);
      if (brandMatch) state.brand = brandMatch.label;
    }

    if (modelSlug) {
      modelMatch = findBySlug(getOptionsForKey(index, state, 'model'), modelSlug);
      if (modelMatch) state.model = modelMatch.label;
    }

    if (yearSlug && yearSlug !== slugify(CLEAR_LABELS.year)) {
      yearMatch = findBySlug(getOptionsForKey(index, state, 'year'), yearSlug);
      if (yearMatch) state.year = yearMatch.label;
    }

    return state;
  }

  function updateUrl(section, state) {
    var url = new URL(window.location.href);

    FIELD_KEYS.forEach(function (key) {
      var queryKey = getQueryKey(section, key);
      if (state[key]) {
        url.searchParams.set(queryKey, slugify(state[key]));
      } else {
        url.searchParams.delete(queryKey);
      }
    });

    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function cleanInvalidSelections(index, state) {
    if (state.brand && !findByLabel(index.brands, state.brand)) {
      state.brand = '';
      state.model = '';
      state.year = '';
      return;
    }

    if (state.model && !findByLabel(getOptionsForKey(index, state, 'model'), state.model)) {
      state.model = '';
      state.year = '';
    }

    if (state.year && !findByLabel(getOptionsForKey(index, state, 'year'), state.year)) {
      state.year = '';
    }
  }

  function resetFollowingFields(state, key) {
    var index = FIELD_KEYS.indexOf(key);
    if (index < 0) return;

    FIELD_KEYS.slice(index + 1).forEach(function (fieldKey) {
      state[fieldKey] = '';
    });
  }

  function countActiveFilters(state) {
    return FIELD_KEYS.reduce(function (count, key) {
      return count + (state[key] ? 1 : 0);
    }, 0);
  }

  function hasActiveFilter(state) {
    return countActiveFilters(state) > 0;
  }

  function getProductRefsForState(index, state) {
    var refs = new Set();
    var brand = getBrandNode(index, state);
    var models = getModelNodes(index, state);

    if (!index.productIds.length) return [];

    if (!hasActiveFilter(state)) {
      return index._allProductRefs;
    }

    if (state.year) {
      models.forEach(function (model) {
        var year = findByLabel(model.years, state.year);
        var allYears = findByLabel(model.years, CLEAR_LABELS.year);
        if (year) addRefs(refs, year.productRefs);
        if (state.year.toLowerCase() !== CLEAR_LABELS.year.toLowerCase() && allYears) {
          addRefs(refs, allYears.productRefs);
        }
      });

      return Array.from(refs);
    }

    if (state.model) {
      models.forEach(function (model) {
        addRefs(refs, model.productRefs);
      });
      return Array.from(refs);
    }

    if (state.brand && brand) {
      return brand.productRefs;
    }

    return index._allProductRefs;
  }

  function refsToProductIdSet(index, refs) {
    var ids = new Set();
    normalizeProductRefs(refs).forEach(function (ref) {
      var productId = index.productIds[ref];
      if (productId) ids.add(productId);
    });
    return ids;
  }

  function getProductIdSetForState(index, state) {
    var key = [state.brand, state.model, state.year].join('\u0001');

    if (!index._productIdSetCache.has(key)) {
      index._productIdSetCache.set(key, refsToProductIdSet(index, getProductRefsForState(index, state)));
    }

    return index._productIdSetCache.get(key);
  }

  function getProductIdsForState(index, state) {
    return getProductRefsForState(index, state)
      .map(function (ref) { return index.productIds[ref]; })
      .filter(Boolean);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function toMoneyNumber(value) {
    var amount = Number(value);
    return Number.isFinite(amount) ? amount : 0;
  }

  function formatMoney(value) {
    return '$' + toMoneyNumber(value).toFixed(2);
  }

  function getPromoPrices(variant) {
    var price = toMoneyNumber(variant && variant.price);
    var compare = toMoneyNumber(variant && variant.compareAtPrice);
    var original = compare > price ? compare : price;

    return {
      price: original * 0.9,
      compare: original,
      onSale: original > 0
    };
  }

  function getVariantImage(product, variant) {
    if (variant && variant.image) return variant.image;
    return product && product.image ? product.image : '';
  }

  function getProductUrl(product, variant) {
    var handle = product && product.handle ? product.handle : '';
    var url = handle ? '/products/' + encodeURIComponent(handle) : '#';
    if (variant && variant.id) url += '?variant=' + encodeURIComponent(variant.id);
    return url;
  }

  function getSelectedVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    return variants.find(function (variant) { return variant.available; }) || variants[0] || null;
  }

  function getColorOption(product) {
    var options = Array.isArray(product && product.options) ? product.options : [];
    return options.find(function (option) {
      var name = String(option.name || '').toLowerCase();
      return name.indexOf('color') !== -1 || name.indexOf('style') !== -1;
    }) || null;
  }

  function getVariantOptionValue(variant, position) {
    if (!variant || !position) return '';
    if (position === 1) return variant.option1 || '';
    if (position === 2) return variant.option2 || '';
    if (position === 3) return variant.option3 || '';
    return '';
  }

  function findVariantForOptionValue(product, option, value) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    var position = Number(option && option.position || 0);
    var target = String(value || '');
    var availableVariant = variants.find(function (variant) {
      return variant.available && getVariantOptionValue(variant, position) === target;
    });

    return availableVariant || variants.find(function (variant) {
      return getVariantOptionValue(variant, position) === target;
    }) || null;
  }

  function getSwatchStyle(image) {
    return image ? '--am-swatch-image: url(&quot;' + escapeAttribute(image) + '&quot;);' : '';
  }

  function renderSwatches(product, selectedVariant) {
    var option = getColorOption(product);
    var values = Array.isArray(option && option.values) ? option.values : [];
    var selectedId = selectedVariant && selectedVariant.id;

    if (!option || values.length <= 1) return '';

    var buttons = values.map(function (value, index) {
      var variant = findVariantForOptionValue(product, option, value);
      if (!variant) return '';

      var prices = getPromoPrices(variant);
      var swatchImage = variant.image || '';
      if (!swatchImage) return '';

      return [
        '<button',
        ' class="am-card__swatch has-image' + (variant.id === selectedId ? ' is-active' : '') + '"',
        ' type="button"',
        ' aria-label="' + escapeAttribute(value) + '"',
        ' aria-pressed="' + String(variant.id === selectedId) + '"',
        ' style="' + getSwatchStyle(swatchImage) + '"',
        ' data-am-card-swatch',
        ' data-am-card-swatch-index="' + index + '"',
        ' data-variant-id="' + escapeAttribute(variant.id) + '"',
        ' data-price-html="' + escapeAttribute(formatMoney(prices.price)) + '"',
        ' data-compare-price-html="' + escapeAttribute(formatMoney(prices.compare)) + '"',
        ' data-on-sale="' + String(prices.onSale) + '"',
        ' data-available="' + String(variant.available) + '"',
        ' data-image="' + escapeAttribute(swatchImage) + '"',
        '>',
        '</button>'
      ].join('');
    }).join('');

    return buttons
      ? [
        '<div class="am-card__swatch-row am-card__swatch-carousel" data-am-card-swatch-row data-am-card-swatch-carousel>',
        '<button class="am-card__swatch-nav am-card__swatch-nav--prev" type="button" aria-label="Previous styles" data-am-card-swatch-nav="prev" hidden></button>',
        '<div class="am-card__swatch-viewport" data-am-card-swatch-viewport>',
        '<div class="am-card__swatches am-card__swatch-track" aria-label="' + escapeAttribute(option.name) + '" data-am-card-swatch-list data-am-card-swatch-track>' + buttons + '</div>',
        '</div>',
        '<button class="am-card__swatch-nav am-card__swatch-nav--next" type="button" aria-label="Next styles" data-am-card-swatch-nav="next" hidden></button>',
        '</div>'
      ].join('')
      : '';
  }

  function renderIndexedCard(product, fitmentLabel, showRating) {
    var selectedVariant = getSelectedVariant(product);
    if (!product || !selectedVariant) return '';

    var prices = getPromoPrices(selectedVariant);
    var productUrl = getProductUrl(product, selectedVariant);
    var image = getVariantImage(product, selectedVariant);
    var title = product.title || '';
    var subtitle = fitmentLabel || '';

    return [
      '<div class="am-ymm-filtered__slot" data-am-ymm-product-card data-product-id="' + escapeAttribute(product.id) + '">',
      '<article class="am-card" data-am-card>',
      '<div class="am-card__media-panel">',
      '<div class="am-card__topline">',
      '<span class="am-card__badge" data-am-sale-badge>Sale</span>',
      '</div>',
      '<a class="am-card__image-link" href="' + escapeAttribute(productUrl) + '" aria-label="' + escapeAttribute(title) + '" data-am-product-link>',
      image
        ? '<img class="am-card__image" src="' + escapeAttribute(image) + '" alt="' + escapeAttribute(product.imageAlt || title) + '" loading="lazy" data-am-card-image>'
        : '<span class="am-card__image-placeholder" aria-hidden="true"></span>',
      '</a>',
      '</div>',
      '<div class="am-card__body">',
      '<div class="am-card__main-copy">',
      '<a class="am-card__title" href="' + escapeAttribute(productUrl) + '" data-am-product-link>' + escapeHtml(title) + '</a>',
      '<div class="am-card__subtitle" data-am-card-subtitle' + (subtitle ? '' : ' hidden') + '>' + escapeHtml(subtitle) + '</div>',
      '</div>',
      renderSwatches(product, selectedVariant),
      '<div class="am-card__purchase">',
      '<div class="am-card__rating-price">',
      showRating ? '<div class="am-card__rating" aria-label="5 out of 5 stars"><span aria-hidden="true">★★★★★</span></div>' : '',
      '<div class="am-card__price-wrap">',
      '<span class="am-card__price" data-am-card-price>' + escapeHtml(formatMoney(prices.price)) + '</span>',
      '<span class="am-card__compare" data-am-card-compare>' + escapeHtml(formatMoney(prices.compare)) + '</span>',
      '</div>',
      '</div>',
      '<form is="product-form" class="am-card__form shopify-product-form" method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" data-cart-add-url="/cart/add" data-am-card-form>',
      '<input type="hidden" name="form_type" value="product">',
      '<input type="hidden" name="utf8" value="&#10003;">',
      '<input type="hidden" name="id" value="' + escapeAttribute(selectedVariant.id) + '" data-am-card-variant-input>',
      '<input type="hidden" name="quantity" value="1">',
      '<button class="am-card__button" type="submit"' + (selectedVariant.available ? '' : ' disabled') + '>Add to Cart</button>',
      '</form>',
      '</div>',
      '</div>',
      '</article>',
      '</div>'
    ].join('');
  }

  function buildMobileFields(section) {
    var mobile = section.querySelector('.am-ymm-filtered__mobile-fields');
    var desktop = section.querySelector('.am-ymm-filtered__bike');
    if (!mobile || !desktop || mobile.children.length) return;

    FIELD_KEYS.forEach(function (key) {
      var source = desktop.querySelector('[data-am-ymm-field="' + key + '"]');
      if (!source) return;

      var clone = source.cloneNode(true);
      clone.classList.remove('is-open');
      var button = clone.querySelector('[data-am-ymm-toggle]');
      if (button) button.setAttribute('aria-expanded', 'false');
      var panel = clone.querySelector('[data-am-ymm-panel]');
      if (panel) panel.innerHTML = '';
      mobile.appendChild(clone);
    });
  }

  function closeAllPanels(section) {
    section.querySelectorAll('[data-am-ymm-field]').forEach(function (field) {
      field.classList.remove('is-open');
      var button = field.querySelector('[data-am-ymm-toggle]');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }

  function getCurrentFieldLabel(state, key) {
    if (state[key]) return state[key];
    if (key === 'year' && (state.brand || state.model)) return CLEAR_LABELS.year;
    return FIELD_LABELS[key];
  }

  function renderOptions(section, index, state, onSelect) {
    section.querySelectorAll('[data-am-ymm-field]').forEach(function (field) {
      var key = field.getAttribute('data-am-ymm-field');
      var current = field.querySelector('[data-am-ymm-current]');
      var panel = field.querySelector('[data-am-ymm-panel]');
      if (!key || !current || !panel) return;

      current.textContent = getCurrentFieldLabel(state, key);
      panel.innerHTML = '';

      var clearButton = document.createElement('button');
      clearButton.type = 'button';
      clearButton.className = 'am-ymm-filtered__option am-ymm-filtered__option--clear' + (!state[key] ? ' is-selected' : '');
      clearButton.setAttribute('role', 'option');
      clearButton.setAttribute('aria-selected', String(!state[key]));
      clearButton.textContent = CLEAR_LABELS[key];
      clearButton.addEventListener('click', function () {
        onSelect(key, '');
      });
      panel.appendChild(clearButton);

      getOptionsForKey(index, state, key).forEach(function (option) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'am-ymm-filtered__option' + (state[key] === option.label ? ' is-selected' : '');
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', String(state[key] === option.label));
        button.textContent = option.label;
        button.addEventListener('click', function () {
          onSelect(key, option.label);
        });
        panel.appendChild(button);
      });
    });
  }

  function cleanBrandLabel(value) {
    return String(value || '').replace(/^For\s+/i, '').trim();
  }

  function formatYearRange(years) {
    var uniqueYears = uniqBySlug(years, 'year')
      .map(function (item) { return item.label; })
      .filter(Boolean);
    var numericYears = uniqueYears
      .map(function (year) { return Number(year); })
      .filter(function (year) { return !Number.isNaN(year); });

    if (numericYears.length === uniqueYears.length && numericYears.length > 1) {
      numericYears.sort(function (a, b) { return a - b; });

      var isConsecutive = numericYears.every(function (year, index) {
        return index === 0 || year === numericYears[index - 1] + 1;
      });

      if (isConsecutive) {
        return numericYears[0] + '-' + numericYears[numericYears.length - 1];
      }

      return numericYears.join(', ');
    }

    return uniqueYears.join(', ');
  }

  function getProductFitments(index, productId, state) {
    var fitments = index._productFitmentsById.get(productId) || [];

    if (!hasActiveFilter(state)) return fitments;

    var filtered = fitments.filter(function (fitment) {
      if (state.brand && fitment.brand !== state.brand) return false;
      if (state.model && fitment.model !== state.model) return false;
      if (state.year && fitment.year !== state.year && fitment.year.toLowerCase() !== 'all years') return false;
      return true;
    });

    return filtered.length ? filtered : fitments;
  }

  function getFitmentLabelForProduct(index, productId, state) {
    var cardRows = getProductFitments(index, productId, state);
    if (!cardRows.length) return '';

    var first = cardRows[0];
    var sameBikeRows = cardRows.filter(function (row) {
      return row.brand === first.brand && row.model === first.model;
    });
    var brand = cleanBrandLabel(first.brand).toUpperCase();
    var model = String(first.model || '').trim().toUpperCase();
    var years = formatYearRange(sameBikeRows.map(function (row) { return row.year; }));

    return [brand, model, years].filter(Boolean).join(' ');
  }

  function updateCardFitment(card, index, state) {
    var subtitle = card.querySelector('[data-am-card-subtitle]');
    if (!subtitle) return;

    var label = getFitmentLabelForProduct(index, card.getAttribute('data-product-id'), state);
    subtitle.textContent = label;
    subtitle.hidden = !label;
  }

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MEDIA).matches;
  }

  function getBaseVisibleLimit() {
    return isMobileViewport() ? MOBILE_COLLAPSED_LIMIT : DESKTOP_VISIBLE_LIMIT;
  }

  function getLoadMoreStep() {
    return isMobileViewport() ? MOBILE_COLLAPSED_LIMIT : DESKTOP_VISIBLE_LIMIT;
  }

  function getVisibleLimit(group) {
    var storedLimit = Number(group.dataset.amYmmVisibleLimit);
    var baseLimit = getBaseVisibleLimit();

    if (!Number.isNaN(storedLimit) && storedLimit > baseLimit) return storedLimit;
    return baseLimit;
  }

  function setCountText(countNode, count) {
    if (!countNode) return;

    if (count <= 0) {
      countNode.textContent = '';
      countNode.hidden = true;
      return;
    }

    countNode.textContent = count + (count === 1 ? ' item' : ' items');
    countNode.hidden = false;
  }

  function getUniqueProductIdsForState(index, state) {
    var seen = new Set();

    return getProductIdsForState(index, state).filter(function (id) {
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }

  function getIndexedProductsForState(fitmentIndex, productIndex, state) {
    return getUniqueProductIdsForState(fitmentIndex, state)
      .map(function (productId) { return productIndex.products[productId]; })
      .filter(Boolean);
  }

  function shouldShowRating(section) {
    return section.getAttribute('data-show-rating') !== 'false';
  }

  function hasIndexedProducts(productIndex) {
    return Boolean(productIndex && productIndex.products && Object.keys(productIndex.products).length);
  }

  function activateFallbackGrid(group, grid) {
    var template = group.querySelector('[data-am-ymm-fallback-template]');
    if (!template || !grid) return false;

    if (group.dataset.amYmmFallbackActive !== 'true') {
      grid.innerHTML = template.innerHTML;
      group.dataset.amYmmFallbackActive = 'true';

      if (window.AM_FIGMA_PRODUCT_CARDS && typeof window.AM_FIGMA_PRODUCT_CARDS.initCards === 'function') {
        window.AM_FIGMA_PRODUCT_CARDS.initCards(grid);
      }
    }

    return true;
  }

  function renderIndexedProductGroup(section, group, fitmentIndex, productIndex, state) {
    var grid = group.querySelector('[data-am-ymm-grid]');
    var empty = group.querySelector('[data-am-ymm-empty]');
    var viewMore = group.querySelector('[data-am-ymm-view-more]');
    var countNode = group.querySelector('[data-am-ymm-result-count]');
    var limit = getVisibleLimit(group);
    var filtered = hasActiveFilter(state);
    var hasProductIndex = hasIndexedProducts(productIndex);
    var products = getIndexedProductsForState(fitmentIndex, productIndex, state);
    var visibleProducts = products.slice(0, limit);
    var showRating = shouldShowRating(section);

    if (!hasProductIndex && activateFallbackGrid(group, grid)) {
      filterDomProductGroup(
        group,
        fitmentIndex,
        state,
        fitmentIndex.productIds.length ? getProductIdSetForState(fitmentIndex, state) : null
      );
      return;
    }

    group.dataset.amYmmFallbackActive = 'false';

    if (grid) {
      grid.innerHTML = visibleProducts.map(function (product) {
        return renderIndexedCard(
          product,
          getFitmentLabelForProduct(fitmentIndex, product.id, state),
          showRating
        );
      }).join('');

      if (window.AM_FIGMA_PRODUCT_CARDS && typeof window.AM_FIGMA_PRODUCT_CARDS.initCards === 'function') {
        window.AM_FIGMA_PRODUCT_CARDS.initCards(grid);
      }
    }

    setCountText(countNode, products.length);

    if (empty) {
      empty.hidden = !filtered || products.length !== 0;
    }

    if (viewMore) {
      viewMore.classList.toggle('is-visible', products.length > limit);
    }
  }

  function filterDomProductGroup(group, index, state, targetIds) {
    var cards = Array.prototype.slice.call(group.querySelectorAll('[data-am-ymm-product-card]'));
    var empty = group.querySelector('[data-am-ymm-empty]');
    var viewMore = group.querySelector('[data-am-ymm-view-more]');
    var countNode = group.querySelector('[data-am-ymm-result-count]');
    var limit = getVisibleLimit(group);
    var filtered = hasActiveFilter(state);
    var eligibleIndex = 0;
    var eligibleCount = 0;

    cards.forEach(function (card) {
      var productId = card.getAttribute('data-product-id');
      var eligible = !targetIds || targetIds.has(productId);
      var visible = eligible && eligibleIndex < limit;

      updateCardFitment(card, index, state);

      if (eligible) {
        eligibleIndex += 1;
        eligibleCount += 1;
      }

      card.hidden = !visible;
    });

    setCountText(countNode, eligibleCount);

    if (empty) {
      empty.hidden = !filtered || eligibleCount !== 0;
    }

    if (viewMore) {
      viewMore.classList.toggle('is-visible', eligibleCount > limit);
    }
  }

  function applyProductFiltering(section, index, state, productIndex) {
    var targetIds = index.productIds.length ? getProductIdSetForState(index, state) : null;

    section.querySelectorAll('[data-am-ymm-product-group]').forEach(function (group) {
      if (group.getAttribute('data-am-ymm-product-source') === 'index') {
        renderIndexedProductGroup(section, group, index, productIndex || normalizeProductIndex(null), state);
        return;
      }

      filterDomProductGroup(group, index, state, targetIds);
    });
  }

  function updateHeaderOffset(section) {
    section.style.setProperty('--am-ymm-header-offset', getHeaderOffset() + 'px');
  }

  function getDocumentTop(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  }

  function getDocumentBottom(element) {
    return getDocumentTop(element) + element.offsetHeight;
  }

  function getAnchorContainer(target) {
    if (!target) return null;

    var container = target.closest('.shopify-section, [id^="shopify-section"], section');
    if (container) return container;

    var current = target.parentElement;
    while (current && current !== document.body) {
      if (current.offsetHeight >= Math.max(target.offsetHeight, window.innerHeight * 0.75)) {
        return current;
      }
      current = current.parentElement;
    }

    return target;
  }

  function getAnchorRange(selector) {
    var target = queryTarget(selector);
    if (!target) return null;

    var container = getAnchorContainer(target) || target;
    return {
      selector: selector,
      target: target,
      top: getDocumentTop(target),
      bottom: Math.max(getDocumentBottom(target), getDocumentBottom(container))
    };
  }

  function getPageContentBottom() {
    var scrollBottom = Math.max(
      document.body ? document.body.scrollHeight : 0,
      document.documentElement ? document.documentElement.scrollHeight : 0
    );
    var candidates = Array.prototype.slice.call(
      document.querySelectorAll('main, .main-content, [role="main"], #main')
    );
    var layoutBottom = candidates.reduce(function (bottom, element) {
      if (['SCRIPT', 'STYLE', 'TEMPLATE', 'LINK', 'META'].indexOf(element.tagName) !== -1) return bottom;
      if (element.offsetHeight <= 0) return bottom;
      return Math.max(bottom, getDocumentBottom(element));
    }, 0);

    return Math.max(scrollBottom, layoutBottom);
  }

  function getAnchorRanges(tabs) {
    var ranges = tabs.map(function (tab) {
      var range = getAnchorRange(tab.getAttribute('data-am-ymm-anchor'));
      if (!range) return null;
      range.tab = tab;
      return range;
    }).filter(Boolean);

    var ordered = ranges.slice().sort(function (a, b) { return a.top - b.top; });
    var pageBottom = getPageContentBottom();

    ordered.forEach(function (range, index) {
      var next = ordered[index + 1];
      range.bottom = Math.max(range.bottom, next ? next.top : pageBottom);
    });

    return ranges;
  }

  function updateFixedNav(section, tabs) {
    var nav = section.querySelector('[data-am-ymm-sticky-nav]');
    var placeholder = section.querySelector('[data-am-ymm-nav-placeholder]');
    if (!nav || !placeholder) return;

    var headerOffset = getHeaderOffset();
    var navHeight = nav.offsetHeight;
    var anchor = placeholder.classList.contains('is-active') ? placeholder : nav;
    var start = getDocumentTop(anchor);
    var end = getDocumentBottom(section);

    getAnchorRanges(tabs).forEach(function (range) {
      if (range) {
        end = Math.max(end, range.bottom);
      }
    });

    var shouldFix = window.scrollY + headerOffset >= start
      && window.scrollY + headerOffset < end - navHeight;

    section.style.setProperty('--am-ymm-header-offset', headerOffset + 'px');
    section.style.setProperty('--am-ymm-nav-height', navHeight + 'px');
    placeholder.style.height = navHeight + 'px';
    placeholder.hidden = !shouldFix;
    placeholder.classList.toggle('is-active', shouldFix);
    nav.classList.toggle('is-fixed', shouldFix);
  }

  function setMobileFilterExpanded(section, expanded) {
    var nav = section.querySelector('[data-am-ymm-sticky-nav]');
    if (!nav) return false;

    var wasHidden = nav.classList.contains('is-mobile-filter-hidden');
    var shouldHide = !expanded;
    nav.classList.toggle('is-mobile-filter-hidden', shouldHide);

    section.querySelectorAll('[data-am-ymm-mobile-filter-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', String(!shouldHide));
    });

    if (shouldHide) closeAllPanels(section);
    return wasHidden !== shouldHide;
  }

  function updateMobileFilterVisibility(section, previousScrollY) {
    var nav = section.querySelector('[data-am-ymm-sticky-nav]');
    if (!nav) return false;

    var currentScrollY = window.scrollY;
    var delta = currentScrollY - previousScrollY;
    var hasOpenPanel = Boolean(section.querySelector('.am-ymm-filtered__mobile-filter .am-ymm-filtered__field.is-open'));

    if (!isMobileViewport() || !nav.classList.contains('is-fixed') || hasOpenPanel) {
      return setMobileFilterExpanded(section, true);
    }

    if (currentScrollY <= getDocumentTop(section) + 24) {
      return setMobileFilterExpanded(section, true);
    }

    if (delta > 8) {
      return setMobileFilterExpanded(section, false);
    }

    return false;
  }

  function scrollToTarget(section, selector) {
    var range = getAnchorRange(selector);
    if (!range) return;

    var nav = section.querySelector('[data-am-ymm-sticky-nav]');
    var offset = getHeaderOffset() + (nav ? nav.offsetHeight : 0) + 16;
    var top = range.top - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function scrollToTopPicks(section) {
    var firstTab = section.querySelector('[data-am-ymm-anchor]');
    if (!firstTab) return;

    section.querySelectorAll('[data-am-ymm-anchor]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab === firstTab);
    });

    window.setTimeout(function () {
      scrollToTarget(section, firstTab.getAttribute('data-am-ymm-anchor'));
    }, 0);
  }

  function resetExpandedProductGroups(section) {
    section.querySelectorAll('[data-am-ymm-product-group]').forEach(function (group) {
      delete group.dataset.amYmmVisibleLimit;
    });
  }

  function resetFilterState(state) {
    FIELD_KEYS.forEach(function (key) {
      state[key] = '';
    });
  }

  function initAnchors(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-am-ymm-anchor]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item) { item.classList.remove('is-active'); });
        tab.classList.add('is-active');
        scrollToTarget(section, tab.getAttribute('data-am-ymm-anchor'));
      });
    });

    var ticking = false;
    var lastScrollY = window.scrollY;
    function onScroll() {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(function () {
        updateFixedNav(section, tabs);
        if (updateMobileFilterVisibility(section, lastScrollY)) {
          updateFixedNav(section, tabs);
        }

        var nav = section.querySelector('[data-am-ymm-sticky-nav]');
        var offset = getHeaderOffset() + (nav ? nav.offsetHeight : 0) + 80;
        var activeTab = null;

        getAnchorRanges(tabs).forEach(function (range) {
          var current = window.scrollY + offset;

          if (current >= range.top && current < range.bottom) {
            activeTab = range.tab;
          }
        });

        if (activeTab) {
          tabs.forEach(function (item) { item.classList.toggle('is-active', item === activeTab); });
        }

        lastScrollY = window.scrollY;
        ticking = false;
      });
    }

    updateFixedNav(section, tabs);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      setMobileFilterExpanded(section, true);
      lastScrollY = window.scrollY;
      updateFixedNav(section, tabs);
    }, { passive: true });
  }

  function initFieldInteractions(section, index, productIndex, state, refresh) {
    section.addEventListener('click', function (event) {
      var mobileFilterToggle = event.target.closest('[data-am-ymm-mobile-filter-toggle]');
      if (mobileFilterToggle && section.contains(mobileFilterToggle)) {
        var nav = section.querySelector('[data-am-ymm-sticky-nav]');
        var isExpanded = !nav || !nav.classList.contains('is-mobile-filter-hidden');
        if (setMobileFilterExpanded(section, !isExpanded)) {
          window.requestAnimationFrame(function () {
            var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-am-ymm-anchor]'));
            updateFixedNav(section, tabs);
          });
        }
        return;
      }

      var toggle = event.target.closest('[data-am-ymm-toggle]');
      if (!toggle || !section.contains(toggle)) return;

      var field = toggle.closest('[data-am-ymm-field]');
      if (!field) return;

      var isOpen = field.classList.contains('is-open');
      setMobileFilterExpanded(section, true);
      closeAllPanels(section);
      field.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    document.addEventListener('click', function (event) {
      if (!section.contains(event.target)) {
        closeAllPanels(section);
      }
    });

    section.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllPanels(section);
    });

    section.querySelectorAll('[data-am-ymm-view-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('[data-am-ymm-product-group]');
        if (group) {
          group.dataset.amYmmVisibleLimit = String(getVisibleLimit(group) + getLoadMoreStep());
        }
        applyProductFiltering(section, index, state, productIndex);
      });
    });

    section.querySelectorAll('[data-am-ymm-clear-filters]').forEach(function (button) {
      button.addEventListener('click', function () {
        resetFilterState(state);
        resetExpandedProductGroups(section);
        refresh(true);
        closeAllPanels(section);
        scrollToTopPicks(section);
      });
    });
  }

  function initSection(section) {
    if (section.dataset.amYmmInitialized === 'true') return;
    section.dataset.amYmmInitialized = 'true';

    buildMobileFields(section);
    updateHeaderOffset(section);
    initAnchors(section);

    Promise.all([
      fetchFitmentIndex(section),
      fetchProductIndex(section)
    ]).then(function (results) {
      var index = results[0];
      var productIndex = results[1];
      var state = getStateFromUrl(section, index);
      cleanInvalidSelections(index, state);

      if (!index.productIds.length) {
        var message = section.querySelector('[data-am-ymm-data-message]');
        if (message) message.hidden = false;
      }

      function selectValue(key, value) {
        state[key] = value;
        resetFollowingFields(state, key);
        cleanInvalidSelections(index, state);
        resetExpandedProductGroups(section);
        refresh(true);
        closeAllPanels(section);
        scrollToTopPicks(section);
      }

      function refresh(updateHistory) {
        renderOptions(section, index, state, selectValue);
        applyProductFiltering(section, index, state, productIndex);
        if (updateHistory) updateUrl(section, state);
      }

      initFieldInteractions(section, index, productIndex, state, refresh);
      refresh(false);

      window.addEventListener('resize', function () {
        updateHeaderOffset(section);
        applyProductFiltering(section, index, state, productIndex);
      }, { passive: true });

      window.addEventListener('popstate', function () {
        state = getStateFromUrl(section, index);
        cleanInvalidSelections(index, state);
        refresh(false);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-am-ymm-filtered-collections]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector('[data-am-ymm-filtered-collections]');
    if (section) initSection(section);
  });
})();
